import { SettingsConfigType } from "../../../index";

interface SettingsConfigProps {
	id: string;
	label: string;
	description?: string;
	type: SettingsConfigType;
	default_value?: any;
	required?: boolean | false;
	editable?: boolean | true;
	validators?: string;
	encrypted?: boolean | false;
	children?: SettingsConfig[];
	data?: any;
}

class SettingsConfig {
	constructor(public _: SettingsConfigProps) {}

	static fromJson(json: any) {
		return new SettingsConfig({
			id: json.id,
			label: json.label,
			description: json.description,
			type: json.type,
			default_value: json.default_value,
			required: json.required,
			editable: json.editable,
			validators: json.validators,
			encrypted: json.encrypted,
			children: json.children?.map((child: any) =>
				SettingsConfig.fromJson(child)
			),
			data: json.data,
		});
	}

	toJson(): any {
		return {
			id: this._.id,
			label: this._.label,
			description: this._.description,
			type: this._.type,
			default_value: this._.default_value,
			required: this._.required,
			editable: this._.editable,
			validators: this._.validators,
			encrypted: this._.encrypted,
			children: this._.children?.map((child) => child.toJson()),
			data: this._.data,
		};
	}
}

export { SettingsConfig };
